"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userConfigUpdated = exports.updateUserConfig = exports.updateAccount = exports.temporarilySetLevelIncreaseStatus = exports.subscribeToVerificationLevelUpdateEvents = exports.processingValidateUserRegistration = exports.finishedValidateUserRegistration = exports.USER_CONFIG_UPDATED = exports.UPDATE_ACCOUNT = exports.PROCESSING_VALIDATE_USER_REGISTRATION = exports.FINISHED_VALIDATE_USER_REGISTRATION = void 0;
var _verificationLevelUpdateService = _interopRequireDefault(require("../../services/subscriptions/verificationLevelUpdateService"));
var _sidePaneActions = require("./sidePaneActions");
var _kycLevelsSelectors = require("../selectors/kycLevelsSelectors");
var _arrayHelper = require("../../helpers/arrayHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UPDATE_ACCOUNT = exports.UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
var USER_CONFIG_UPDATED = exports.USER_CONFIG_UPDATED = 'USER_CONFIG_UPDATED';
var PROCESSING_VALIDATE_USER_REGISTRATION = exports.PROCESSING_VALIDATE_USER_REGISTRATION = 'PROCESSING_VALIDATE_USER_REGISTRATION';
var FINISHED_VALIDATE_USER_REGISTRATION = exports.FINISHED_VALIDATE_USER_REGISTRATION = 'FINISHED_VALIDATE_USER_REGISTRATION';
var processingValidateUserRegistration = exports.processingValidateUserRegistration = {
  type: PROCESSING_VALIDATE_USER_REGISTRATION
};
var finishedValidateUserRegistration = exports.finishedValidateUserRegistration = {
  type: FINISHED_VALIDATE_USER_REGISTRATION
};
var updateAccount = exports.updateAccount = function updateAccount(payload) {
  return {
    type: UPDATE_ACCOUNT,
    payload: payload
  };
};
var userConfigUpdated = exports.userConfigUpdated = function userConfigUpdated(payload) {
  return {
    type: USER_CONFIG_UPDATED,
    payload: payload
  };
};
var updateUserConfig = exports.updateUserConfig = function updateUserConfig(userConfigUpdatedPayload) {
  var closeSidePane = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch(userConfigUpdated(userConfigUpdatedPayload));
    if (closeSidePane) dispatch((0, _sidePaneActions.closeKYCSidePane)());
  };
};
var subscribeToVerificationLevelUpdateEvents = exports.subscribeToVerificationLevelUpdateEvents = function subscribeToVerificationLevelUpdateEvents(state) {
  return function (dispatch) {
    var stateItem = _objectSpread({}, state);
    _verificationLevelUpdateService["default"].subscribe(function (update) {
      stateItem.VerificationLevel = update.VerificationLevel;
      var payload = {
        index: 0,
        item: stateItem
      };
      dispatch(updateAccount(payload));
    });
  };
};
var temporarilySetLevelIncreaseStatus = exports.temporarilySetLevelIncreaseStatus = function temporarilySetLevelIncreaseStatus(_ref) {
  var levelIncreaseStatus = _ref.levelIncreaseStatus;
  return function (dispatch, getState) {
    var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(getState()),
      userConfig = _kycLevelFormSelector.userConfig;
    var levelIncreaseStatusIndex = (0, _arrayHelper.findIndexOfObject)(userConfig, 'Key', 'levelIncreaseStatus');
    var setLevelIncreaseStatusPayload = {
      index: levelIncreaseStatusIndex,
      item: {
        Key: 'levelIncreaseStatus',
        Value: levelIncreaseStatus
      }
    };
    dispatch(updateUserConfig(setLevelIncreaseStatusPayload, false));
  };
};